import zhCN from './zh-CN.json';
import enUS from './en-US.json';
import arSA from './ar-SA.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import ptPT from './pt-PT.json';
import ruRU from './ru-RU.json';
import thTH from './th-TH.json';

export default {
  'en-US': enUS, // 英语
  'zh-CN': zhCN, // 中文
  'ar-SA': arSA, // 阿拉伯
  'es-ES': esES, //西班牙
  'fr-FR': frFR, // 法国
  'pt-PT': ptPT, // 葡萄牙
  'ru-RU': ruRU, // 俄罗斯
  'th-TH': thTH, // 泰语
  'pt-BR': ptPT // 葡萄牙
};
